"use client";
import React, { useEffect, useState, useRef } from "react";
import styles from "./HorizontalPhotos.module.scss";
import gsap from "gsap";
import { API_BASE } from "../../../constants/config";

export default function HorizontalPhotos({ messages, horizontalImages }) {
  const containerRef = useRef(null);
  const [timelineGroups, setTimelineGroups] = useState([]);

  const getTimelineGroups = () => {
    const innerContainer = document.querySelector(`.${styles.containerImages}`);
    const innerContainerWidth = innerContainer.getBoundingClientRect().width;

    const barWidth = 1;

    const finalAmmount = Math.trunc((innerContainerWidth + 8) / (barWidth + 8));

    const newTimelineGroups = Array.from(
      { length: finalAmmount },
      (_, index) => index
    );

    setTimelineGroups(newTimelineGroups);
  };

  useEffect(() => {
    getTimelineGroups();
  }, []);

  useEffect(() => {
    if (typeof window !== undefined) {
      let additionalPadding: number;
      let windowSize: number;

      if (window.matchMedia("screen and (max-width: 767px)").matches) {
        additionalPadding = 24;
        windowSize = window.innerWidth;
      } else if (
        window.matchMedia(
          "screen and (min-width: 768px) and (max-width: 999px)"
        ).matches
      ) {
        additionalPadding = 24;
        windowSize = 748;
      } else if (
        window.matchMedia(
          "screen and (min-width: 1000px) and (max-width: 1599px)"
        ).matches
      ) {
        additionalPadding = 60;
        windowSize = window.innerWidth;
      } else if (
        window.matchMedia(
          "screen and (min-width: 1600px) and (max-width: 1899px)"
        ).matches
      ) {
        additionalPadding = 140;
        windowSize = window.innerWidth;
      } else if (window.matchMedia("screen and (min-width: 1900px)").matches) {
        additionalPadding = 140;
        windowSize = 1900;
      }

      const innerContainer = document.querySelector(
        `.${styles.containerImages}`
      );
      const innerContainerWidth = innerContainer.getBoundingClientRect().width;

      const totalXMovement = `-${innerContainerWidth + additionalPadding - (windowSize - additionalPadding)}px`;
      const totalTitleMovement = `${innerContainerWidth + additionalPadding - (windowSize - additionalPadding)}px`;

      const parallaxTimeline = gsap.timeline();

      const images = document.querySelectorAll(
        `.${styles.containerImages} .${styles.picture}`
      );

      const pin = gsap.fromTo(
        `.${styles.containerInner}`,
        {
          translateX: 0,
        },
        {
          translateX: totalXMovement,
          ease: "none",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top top",
            end: `${horizontalImages.length / 2}000 top`,
            scrub: true,
            pin: true,
            invalidateOnRefresh: true,
            fastScrollEnd: true,
          },
        }
      );

      const titleMovement = gsap.fromTo(
        `.${styles.containerTitle}`,
        {
          translateX: 0,
        },
        {
          translateX: totalTitleMovement,
          ease: "none",
          scrollTrigger: {
            trigger: `.${styles.containerImages}`,
            start: "top top",
            end: `${horizontalImages.length / 2}000 top`,
            scrub: true,
            invalidateOnRefresh: true,
            fastScrollEnd: true,
          },
        }
      );

      images.forEach((item, index) => {
        const imgElement = item.querySelector("img");
        const itemRect = item.getBoundingClientRect();

        let startTrigger;
        let startPoint;
        let movement;

        if (itemRect.left < window.innerWidth) {
          startTrigger = item;
          startPoint = `left left+=${itemRect.left}`;
        } else {
          startTrigger = `.${styles.containerImages}`;
          startPoint = `left+=${itemRect.left} right`;
        }

        if (index === 0) {
          movement = "5%";
        } else {
          movement = "7%";
        }

        parallaxTimeline.to(imgElement, {
          x: movement,
          scrollTrigger: {
            trigger: startTrigger,
            start: startPoint,
            endTrigger: item,
            end: "right left",
            containerAnimation: pin,
            scrub: true,
            invalidateOnRefresh: true,
            fastScrollEnd: true,
          },
        });
      });

      return () => {
        pin?.scrollTrigger?.kill();
        pin?.kill();
        titleMovement?.scrollTrigger?.kill();
        titleMovement?.kill();
        parallaxTimeline.kill();
      };
    }
  }, []);

  const shouldBeAbove = (num) => {
    const validIndexs = [2, 6, 9, 13, 16];
    return validIndexs.includes(num);
  };

  return (
    <section
      className={`${styles.containerOuter} container`}
      ref={containerRef}
    >
      <div className={styles.containerInner}>
        <div className={styles.timeline}>
          {timelineGroups.map((item, index) => (
            <div className={styles.timelineBar} key={index}></div>
          ))}
          <div className={styles.timelineNumberConatiner}>
            {horizontalImages.map((item, index) => (
              <div className={styles.timelineNumber} key={index}>
                {index + 1 < 10 ? `0${index + 1}` : index + 1}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.containerImages}>
          <h2 className={`title-section ${styles.containerTitle}`}>
            {messages.first_words}
            <p>
              <span>{messages.second_words}</span>
              <span className="title-outline">{messages.third_word}</span>
            </p>
          </h2>
          {horizontalImages.map((item, index) => (
            <div key={index}>
              {item?.img ? (
                <div
                  className={styles.picture}
                  style={{
                    zIndex: shouldBeAbove(index) ? 10 : 1,
                  }}
                >
                  <div className={styles.overlay}></div>
                  <img
                    src={`${API_BASE}${item.img}`}
                    alt={`Image ${index}`}
                    style={{
                      transform: `translateX(-7%)`,
                    }}
                  />
                </div>
              ) : null}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
